<template>
  <v-app v-resize="onResize">
    <router-view />
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: {
        min: 0,
        init: 0,
        add: 0,
      },
      containerHeight: {
        init: 0,
      },
    };
  },
  created() {
    this.windowHeight.init = window.innerHeight;
  },
  mounted() {
    this.containerHeight.init = this.$refs.container.parentElement.offsetHeight;
    this.onResize();
  },
  methods: {
    onResize() {
      this.windowHeight.add = window.innerHeight - this.windowHeight.init;
      const underSize = this.windowHeight.min - window.innerHeight;
      if (underSize >= 0) {
        const gap = this.windowHeight.init - this.containerHeight.init;
        this.$refs.container.style.height = `${this.windowHeight.min - gap}px`;
      } else {
        this.$refs.container.style.height = `${this.containerHeight.init + this.windowHeight.add}px`;
      }
    },
  },
};
</script>

<style></style>
